import { IconButton } from 'components/Blocks';
import { CircleDollarIcon } from 'components/Icons';

import { useClientOptions } from './OptionsContext';

import { Client } from 'entities';

interface ClientOptionsProps {
  children?: never;
  client: Client;
}

function ClientOptions({ client }: ClientOptionsProps): JSX.Element {
  const { openClientModal } = useClientOptions();

  return (
    // <DropdownMenu align="end">
    //   <DropdownMenuItem onClick={() => openClientModal('BILLING', client)}>
    //     <CircleDollarIcon size={16} />
    //     Billing info
    //   </DropdownMenuItem>
    // </DropdownMenu>
    <IconButton tooltipContent="Billing Info" onClick={() => openClientModal('BILLING', client)}>
      <CircleDollarIcon size={14} />
    </IconButton>
  );
}

export default ClientOptions;
